// @ts-nocheck
import logo1 from "@/assets/logo2.png";
import { Button } from "../ui/button";
import MobileNav from "./MobileNav";
import { Link, useNavigate } from "react-router-dom";
import { useStore } from "@/lib/userDetails/UserDetails";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import Cookies from "js-cookie";
import { CalendarDaysIcon, KeyRound, LogOut, User } from "lucide-react";
import { useToast } from "@/components/hooks/use-toast";
import { HashLink } from "react-router-hash-link";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Image_BASE_URL } from "@/api/apiUrl";

const Navbar = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const token = Cookies.get("token");
  const { user, setUser, setAuthenticated } = useStore();

  const logoutHandler = () => {
    try {
      Cookies.remove("token");
      //@ts-ignore
      setUser(null);
      setAuthenticated(false);
      toast({
        title: "You're Logged Out Successfully!",
        description: "You have been logged out.",
        duration: 5000,
      });
      navigate("/");
    } catch (error) {
      toast({
        title: "Logout Failed",
        description: "An error occurred while logging out.",
        duration: 5000,
      });
    }
  };

  return (
    <div className="w-full flex justify-around p-4 lg:px-32 bg-white shadow-lg max-h-[83px]">
      <div className="hidden md:flex items-center  justify-center">
        <Link to="/">
          <div className="w-36 ">
            <img
              src={logo1}
              alt=""
              width={600}
              height={600}
              className="hidden object-cover md:block w-full h-full"
            />
          </div>
        </Link>
      </div>
      <img src="" alt="" />
      <div className="hidden w-full max-w-md md:flex  items-center justify-between">
        <div className="flex-1 text-center cursor-pointer">
          <HashLink
            smooth
            to="/#home"
            scroll={(el) => window.scrollTo({ top: 0, behavior: "smooth" })}
          >
            Home
          </HashLink>
        </div>
        <div className="flex-1 border-l cursor-pointer border-gray-300 text-center">
          <HashLink smooth to="/#about-us">
            About Us
          </HashLink>
        </div>

        <div className="flex-1 border-l border-gray-300 text-center cursor-pointer">
          <Link to="/all-events">Events</Link>
        </div>
        <div className="flex-1 border-l border-gray-300 text-center cursor-pointer">
          <Link to="/contact-us">Contact</Link>
        </div>
      </div>

      {token === undefined ? (
        <>
          <div className="hidden md:flex space-x-6 items-center">
            <div>
              <Link to="/auth/login/email">
                <button>Login</button>
              </Link>
            </div>
            <div>
              <Link to="/auth/signup">
                <Button className="rounded-3xl">Sign up</Button>
              </Link>
            </div>
          </div>
        </>
      ) : (
        <>
          <div className="hidden md:block">
            <Popover>
              <PopoverTrigger>
                <div className="flex mt-2 gap-1 items-center justify-center">
                  <Avatar className="h-8 w-8">
                    <AvatarImage
                      //@ts-ignore
                      src={`${Image_BASE_URL}/images/profile/${user?.profileImage}`}
                    />
                    <AvatarFallback>
                      <div className=" bg-gray-200 w-12 h-12 rounded-full text-black font-semibold flex items-center justify-center">
                        {user?.name && user?.name[0]?.toUpperCase()}
                      </div>
                    </AvatarFallback>
                  </Avatar>
                  <div className="flex flex-col items-start gap-0 ">
                    <p className="font-semibold  ">{user?.name}</p>
                    {/* <p className="text-xs underline ">{user?.email}</p> */}
                  </div>
                </div>
              </PopoverTrigger>
              <PopoverContent className="w-46  px-2">
                <div className="w-full ">
                  <div className="pl-2 font-semibold pb-1 border-b-2 w-full">
                    My Account
                  </div>
                  <div className="px-3 flex gap-4 flex-col mt-3">
                    <Link to={"/my-profile"}>
                      <div className="flex items-center gap-2 cursor-pointer">
                        <User fill="black" size={17} /> Profile
                      </div>
                    </Link>
                    <Link to={"/my-registration"}>
                      <div className="flex items-center gap-2 cursor-pointer">
                        <CalendarDaysIcon size={17} /> My Registrations
                      </div>
                    </Link>
                    <div
                      onClick={() => {
                        navigate("/change-password");
                      }}
                      className="flex items-center gap-2 cursor-pointer"
                    >
                      <KeyRound size={17} />
                      Change Password
                    </div>
                    <div
                      onClick={logoutHandler}
                      className="flex items-center gap-2 cursor-pointer text-red-500"
                    >
                      <LogOut size={17} className="text-red-500" /> Logout{" "}
                    </div>
                  </div>
                </div>
              </PopoverContent>
            </Popover>
          </div>
        </>
      )}

      <MobileNav />
    </div>
  );
};

export default Navbar;

